import { useWizard } from "react-use-wizard";
import {
  TKeyOfDataWizardTradeIn,
  TNumberKeysOfIFillDataWizardTradeIn,
} from "..";
import FacilityTypeStep from "../../../../../shared/wizard/steps/facilityTypeStep";
import tradeInSteps from "./tradeInSteps";

interface ITradeInStep_8 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardTradeIn) => void;
  data: number[] | null;
  onReset: (key: TKeyOfDataWizardTradeIn[], data: number[]) => void;
}

const TradeInStep_8 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: ITradeInStep_8) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(tradeInSteps.step_7.step);
    if (data) {
      onReset(["selectedFacilityTypeIds"], [data[0]]);
    }
  };

  const handleNextStep = () => {
    goToStep(tradeInSteps.step_9.step);
  };

  const handleChange = (selectedId: number) => {
    if (data?.includes(selectedId)) {
      const dataFiltered = data.filter((id) => id !== selectedId);
      if (dataFiltered) {
        onChange(dataFiltered, "selectedFacilityTypeIds");
      }
    } else {
      if (data && data.length <= 2) {
        onChange([data[0], selectedId], "selectedFacilityTypeIds");
      }
    }
  };

  return (
    <div>
      <FacilityTypeStep
        counterPage={{
          current: tradeInSteps.step_8.page,
          max: tradeInSteps.step_8.maxPage,
        }}
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data}
        mode="repeat"
      />
    </div>
  );
};

export default TradeInStep_8;
